import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import TooltipItem from '../../tools/TooltipItem';
import { hatch } from 'ldrs'
import { connect } from 'react-redux';

hatch.register()
class ExScheduling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            examScheduleData: [],
            buildSet: [],
            roomSet: [],
            onlyConflict: false,
            sortEvent: "",
            departmentFilter: "",
            deptFilterOptions: [],
            eventPrefixFilter: "",
            eventFilterOptions: [],
            buildingFilter: "",
            buildFilterOptions: [],
            analyzeModal: false,
            finalizeModal: false,
            timeError: false,
            timeErrorRecord: "",
            shouldRemove: false,
            shouldRemoveAll: false,
            tableKey: 1,
            filteredScheduleData: [],
            onlyMissing: false
        }

        this.generateNew();
    }

    getTable() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: this.props.activeTerm,
            onlymissing: this.state.onlyMissing,
            onlyconflict: this.state.onlyConflict,
            departmentfilter: this.state.departmentFilter,
            prefixfilter: this.state.eventPrefixFilter,
            buildingfilter: this.state.buildingFilter
        }
        fetch('GetExamSchedules', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
            .then((response) => response.json())
            .then((responseJSON) => { this.tableSet(responseJSON); })
            //.then((responseThen) => { if (isInitialFetch) { this.getBuild(); } })
        //localStorage.setItem("lastFetch", moment());
    }

    getBuild() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
            }
        fetch('GetBuildOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
            .then((response) => response.json())
            .then((responseJSON) => { this.buildSet(responseJSON); })
        fetch('RoomsOfBuild', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
            .then((response) => response.json())
            .then((responseJSON) => { this.roomSet(responseJSON); })
        //localStorage.setItem("lastFetch", moment());
    }

    async tableSet(input) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: this.props.activeTerm
        }
        const response = await fetch('ExSchedFilterOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //var buildOpt = []
        //var evOpt = []
        //var deptOpt = []
        //input.map((item) => {
        //    var findItem = buildOpt.find((x) => x.building === item.building);
        //    if (!findItem) buildOpt.push(item);
        //})
        //input.map((item) => {
        //    var findItem = evOpt.find((x) => x.eventdata.substring(0, x.eventdata.indexOf(" ")) === item.eventdata.substring(0, item.eventdata.indexOf(" ")));
        //    if (!findItem) evOpt.push(item);
        //})
        //input.map((item) => {
        //    var findItem = deptOpt.find((x) => x.dept === item.dept);
        //    if (!findItem) deptOpt.push(item);
        //})
        this.setState({
            examScheduleData: input,
            buildFilterOptions: data.build,
            eventFilterOptions: data.prefix,
            deptFilterOptions: data.dept
        }, () => { this.filterExamData(false) })
    }

    buildSet(input) {
        this.setState({
            buildSet: input
            })
    }

    roomSet(input) {
        this.setState({
            roomSet: input
            })
    }

    componentDidMount() {
        //console.log("prop lock: " + String(this.props.editLock));
    }

    async generateNew() {
        /*
        public bool onlymissing { get; set; }
        public bool onlyconflict { get; set; }
        public String departmentfilter { get; set; }
        public String prefixfilter { get; set; }
        public String buildingfilter { get; set; }
        */
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: this.props.activeTerm,
            onlymissing: this.state.onlyMissing,
            onlyconflict: this.state.onlyConflict,
            departmentfilter: this.state.departmentFilter,
            prefixfilter: this.state.eventPrefixFilter,
            buildingfilter: this.state.buildingFilter
        }
        const response = await fetch('GenerateNewExSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //this.setState({
        //    examScheduleData: data
        //})
        //this.getTable();
        this.tableSet(data);
        this.getBuild();
    }

    async changeSched(pk, type, input) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            badDate: false,
            badDateRecord: ""
        })
        //console.log("change: " + pk + ", " + type + ", " + input);
        if (type == "DATE" && input.length > 10) {
            this.setState({
                badDate: true,
                badDateRecord: pk
            })
            this.getTable();
        }
        else {
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                targetpk: pk,
                updatetype: type,
                newdata: input,
                semester: this.props.activeTerm,
                onlymissing: this.state.onlyMissing,
                onlyconflict: this.state.onlyConflict,
                departmentfilter: this.state.departmentFilter,
                prefixfilter: this.state.eventPrefixFilter,
                buildingfilter: this.state.buildingFilter
            }
            const response = await fetch('UpdateExamSched', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            this.setState({
                examScheduleData: data,
                tableKey: this.state.tableKey + 1
            }, () => { this.filterExamData(false) })
        }
        //localStorage.setItem("lastFetch", moment());
        setTimeout(() => {
            this.setState({
                badDate: false,
                badDateRecord: ""
            })
        }, 6000)
    }    

    checkTimeIssue(starttime, endtime, pk, type) {
        this.setState({
            timeError: false,
            timeErrorRecord: ""
        })
        let newData
        if (type == "START") newData = starttime; else newData = endtime;
        if (starttime > endtime) {
            this.setState({
                timeError: true,
                timeErrorRecord: pk
            })
            setTimeout(() => {
                this.setState({
                    timeError: false,
                    timeErrorRecord: ""
                })
            }, 6000)
        }
        this.changeSched(pk, type, newData);
    }

    async manualExclude(pk) {
        //console.log("excluding: " + pk);
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: this.props.activeTerm,
            targetpk: pk,
            onlymissing: this.state.onlyMissing,
            onlyconflict: this.state.onlyConflict,
            departmentfilter: this.state.departmentFilter,
            prefixfilter: this.state.eventPrefixFilter,
            buildingfilter: this.state.buildingFilter
        }
        //console.log("sending: " + JSON.stringify(toSend));
        const response = await fetch('ManualExclude', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            examScheduleData: data
        }, () => this.tableSet())
    }

    toggleAnalyze() {
        this.setState({
            analyzeModal: !this.state.analyzeModal
        })
    }

    toggleFinalize() {
        this.setState({
            analyzeModal: false,
            finalizeModal: !this.state.finalizeModal
            })
    }

    async finalize() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let removeDecision = "NOR";
        if (this.state.shouldRemoveAll) { removeDecision = "REA" }
        if (this.state.shouldRemove && !this.state.shouldRemoveAll) { removeDecision = "RES" }
        //console.log("finalizing: " + this.props.activeTerm + " with remove decision: " + removeDecision)
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: this.props.activeTerm,
            finalizetype: removeDecision
        }
        const response = await fetch('ExSchedFinalize', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //console.log("finalize");
        this.setState({
            finalizeModal: false,
            shouldRemove: false,
            shouldRemoveAll: false
            })
    }

    async deleteSched(pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        //localStorage.setItem("lastFetch", moment());
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pk: pk,
            onlymissing: this.state.onlyMissing,
            onlyconflict: this.state.onlyConflict,
            departmentfilter: this.state.departmentFilter,
            prefixfilter: this.state.eventPrefixFilter,
            buildingfilter: this.state.buildingFilter
        }
        const response = await fetch('DeleteExSchedRecord', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.tableSet(data);
    }

    toggleCheckbox(field) {
        if (field == "C") {
            this.setState({
                onlyConflict: !this.state.onlyConflict
            }, () => { this.getTable() })
        }
        if (field == "M") {
            this.setState({
                onlyMissing: !this.state.onlyMissing
            }, () => { this.getTable() })
        }
    }

    filterExamData(isFilterChange) {
        //this.setState({
        //    filteredScheduleData: [],
        //    tableKey: this.state.tableKey + 1
        //})
        let sortData = this.state.examScheduleData
        if (this.state.sortEvent != "") {
            if (this.state.sortEvent == "AZ") { sortData = this.state.examScheduleData.sort((a, b) => (a.eventdata > b.eventdata) ? 1 : ((b.eventdata > a.eventdata) ? -1 : 0)) }
            else { sortData = this.state.examScheduleData.sort((a, b) => (a.eventdata < b.eventdata) ? 1 : ((b.eventdata < a.eventdata) ? -1 : 0)) }
        }
        this.setState({
            tableKey: this.state.tableKey + 1,
            filteredScheduleData: sortData
        })
        //if (isFilterChange === true) {
        //    console.log("is filter change")
        //    let filterData = []
        //    if (this.state.onlyConflict) {
        //        if (this.state.onlyMissing) {
        //            filterData = this.state.examScheduleData.filter(remove => remove.conflictcount != "No Conflict")
        //        }
        //        else {
        //            filterData = this.state.examScheduleData.filter(remove => remove.conflictcount != "No Conflict" && remove.conflictcount != "Missing Data")
        //        }
        //    }
        //    if (this.state.onlyMissing) {
        //        if (this.state.onlyConflict) {
        //            filterData = this.state.examScheduleData.filter(remove => remove.conflictcount != "No Conflict")
        //        }
        //        else {
        //            filterData = this.state.examScheduleData.filter(remove => remove.conflictcount == "Missing Data")
        //        }
        //    }
        //    if (!this.state.onlyConflict && !this.state.onlyMissing) {
        //        filterData = this.state.examScheduleData
        //    }
        //    if (this.state.sortEvent != "") {//sort event A-Z, Z-A
        //        if (this.state.sortEvent == "AZ") { filterData = filterData.sort((a, b) => (a.eventdata > b.eventdata) ? 1 : ((b.eventdata > a.eventdata) ? -1 : 0)) }
        //        else { filterData = filterData.sort((a, b) => (a.eventdata < b.eventdata) ? 1 : ((b.eventdata < a.eventdata) ? -1 : 0)) }
        //    }
        //    if (this.state.departmentFilter != "") {//only show these departments
        //        filterData = filterData.filter(remove => remove.dept == this.state.departmentFilter)
        //    }
        //    if (this.state.eventPrefixFilter != "") {//only show these prefixed events
        //        filterData = filterData.filter(remove => remove.eventdata.substring(0, remove.eventdata.indexOf(" ")) == this.state.eventPrefixFilter)
        //    }
        //    if (this.state.buildingFilter != "") {//only show in this building
        //        filterData = filterData.filter(remove => remove.building == this.state.buildingFilter)
        //    }
        //    this.setState({
        //        filteredScheduleData: filterData,
        //        tableKey: this.state.tableKey + 1
        //    })
        //}
        //else {
        //    console.log("is data update")
        //    let filterData = []
        //    if (this.state.filteredScheduleData.length != 0) {
        //        filterData = this.state.examScheduleData.filter(getThis => this.state.filteredScheduleData.some(item => item.pk == getThis.pk))
        //    }
        //    else {
        //        filterData = this.state.examScheduleData
        //    }
        //    this.setState({
        //        filteredScheduleData: filterData,
        //        tableKey: this.state.tableKey + 1
        //    })
        //}
    }

    handleDataFilter() {
        let newData = this.state.filteredScheduleData
        //if (this.state.onlyConflict == true) {
        //    newData = newData.filter(remove => remove.conflictcount != "No Conflict")
        //}
        if (this.state.sortEvent != "") {//sort event A-Z, Z-A
            if (this.state.sortEvent == "AZ") { newData = newData.sort((a, b) => (a.eventdata > b.eventdata) ? 1 : ((b.eventdata > a.eventdata) ? -1 : 0)) }
            else { newData = newData.sort((a, b) => (a.eventdata < b.eventdata) ? 1 : ((b.eventdata < a.eventdata) ? -1 : 0)) }
        }
        if (this.state.departmentFilter != "") {//only show these departments
            newData = newData.filter(remove => remove.dept == this.state.departmentFilter)
        }
        if (this.state.eventPrefixFilter != "") {//only show these prefixed events
            newData = newData.filter(remove => remove.eventdata.substring(0, remove.eventdata.indexOf(" ")) == this.state.eventPrefixFilter)
        }
        if (this.state.buildingFilter != "") {//only show in this building
            newData = newData.filter(remove => remove.building == this.state.buildingFilter)
        }
        this.setState({
            filteredScheduleData: newData,
            tableKey: this.state.tableKey + 1
        })
    }

    render() {//{this.state.examScheduleData.map(item => (
        
        
        //else { newData = this.state.examScheduleData }
        return (
            <div>
                <Modal isOpen={this.state.analyzeModal} toggle={this.toggleAnalyze.bind(this)} size="xl">
                    <ModalHeader toggle={this.toggleAnalyze.bind(this)}>Analyze</ModalHeader>
                    <ModalBody>
                        <h3>Missing Data</h3>
                        {this.state.examScheduleData.filter(remove => remove.conflictcount == "Missing Data").length != 0 && <div>The following events have incomplete scheduling information and are not enumerated to be excluded:<br /></div>}
                        {this.state.examScheduleData.filter(remove => remove.conflictcount == "Missing Data").length == 0 &&<div style={{ color: 'green' }}>All events have scheduling information!<br /></div>}
                        {this.state.examScheduleData.filter(remove => remove.conflictcount == "Missing Data").length != 0 && <Table striped>
                            <thead>
                                <tr>
                                    <th>Event Data</th>
                                    <th>Classroom</th>
                                    <th>Schedule</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.examScheduleData.filter(remove => remove.conflictcount == "Missing Data").map(item => (
                                    <tr>
                                        <td>{item.eventdata}</td>
                                        <td>{item.building}</td>
                                        <td>{item.days}{'  '}{item.classstart} - {item.classend}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>}
                        <br />
                        <h3>Scheduling Conflicts</h3>
                        The following sections have exam scheduling conflicts with other sections that may interfere with the exams.<br />
                        Thsese conflicts are not required to be handled before finalizing.<br />
                        <Table striped>
                            <thead>
                                <tr>
                                    <th>Event Data</th>
                                    <th>Exam Date</th>
                                    <th>Exam Start Time</th>
                                    <th>Exam End Time</th>
                                    <th>Exam Building</th>
                                    <th>Exam Room</th>
                                    <th>Conflicts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.examScheduleData.filter(remove => remove.conflictcount != "Missing Data" && remove.conflictcount != "No Conflict").map(item => (
                                    <tr>
                                        <td>{item.eventdata}</td>
                                        <td>{item.date}</td>
                                        <td>{item.starttime}</td>
                                        <td>{item.endtime}</td>
                                        <td>{item.exambuild}</td>
                                        <td>{item.examroom}</td>
                                        <td>{item.conflictcount}</td>
                                    </tr>
                                    ))}
                            </tbody>
                        </Table>
                        <br />
                        <h3>Questionable Schedules</h3>
                        The following sections have scheduling data that may need some revision. Be sure these look right before you finalize.<br />
                        These are not required to be handled before finalizing, but it might be a good idea to be sure you know what you're doing.<br />
                        <Table striped>
                            <thead>
                                <tr>
                                    <th>Event Data</th>
                                    <th>Exam Date</th>
                                    <th>Exam Start Time</th>
                                    <th>Exam End Time</th>
                                    <th>Exam Building</th>
                                    <th>Exam Room</th>
                                    <th>Conflicts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.examScheduleData.filter(remove => remove.starttime < "05:59:59" || remove.endtime > "22:30:00" ).map(item => (
                                    <tr>
                                        <td>{item.eventdata}</td>
                                        <td>{item.date}</td>
                                        <td>{item.starttime}</td>
                                        <td>{item.endtime}</td>
                                        <td>{item.exambuild}</td>
                                        <td>{item.examroom}</td>
                                        <td>{item.conflictcount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </ModalBody>
                    <ModalFooter>
                        {/*<Button color="primary" onClick={() => this.toggleFinalize()}>Finalize</Button>*/}
                        {this.state.examScheduleData.filter(remove => remove.conflictcount == "Missing Data").length == 0 && !this.props.editLock && 
                            <Button color="primary" onClick={() => this.toggleFinalize()}>Finalize</Button>}
                        &nbsp;<Button onClick={() => this.toggleAnalyze()}>Go Back</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.finalizeModal} toggle={this.toggleFinalize.bind(this)}>
                    <ModalHeader toggle={this.toggleFinalize.bind(this)}>Finalize</ModalHeader>
                    <ModalBody>
                        This will push all current data to PowerCampus for term: {this.props.activeTerm}. Any scheduling conflicts will be added as-is, and any further changes to this information will need to be done in PowerCampus.<br />
                        This action will also disallow further edits to the Exam Scheduling data in UnderTheHood for this term.<br />
                        This action is irreversible.<br />
                        <p />
                        Do you want to remove the class meeting dates during the exam week? &nbsp;<Input type="checkbox" name="shouldremove" id="shouldremove" value={this.state.shouldRemove} onClick={(e) => this.setState({ shouldRemove: e.target.checked })} />
                        {this.state.shouldRemove && <div><br />Only remove class meetings for courses with exams? &nbsp;<Input type="checkbox" name="removeall" id="removeall" value={this.state.shouldRemoveAll} onClick={(e) => this.setState({ shouldRemoveAll: e.target.checked })} /></div>}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.finalize()}>Yes</Button>&nbsp;<Button onClick={() => this.toggleFinalize()}>No</Button>
                    </ModalFooter>
                </Modal>
                <Input type="checkbox" onChange={() => { this.toggleCheckbox("C") }} />{' '}Only Show Conflicts&ensp;&ensp;
                <Input type="checkbox" onChange={() => this.toggleCheckbox("M")} />{' '}Only Show Missing<br />
                <Form className="d-flex">
                    <FormGroup>
                        <Label>Sort By</Label>
                        <Input type="select" onChange={(e) => { this.setState({ sortEvent: e.target.value }, () => this.getTable());  }}>
                            <option default value="">No Sort</option>
                            <option value="AZ">A =&gt; Z</option>
                            <option value="ZA">Z =&gt; A</option>
                        </Input>
                    </FormGroup>
                    &nbsp;&emsp;
                    <FormGroup>
                        <Label>Only Show This Department</Label>
                        <Input type="select" onChange={(e) => { this.setState({ departmentFilter: e.target.value }, () => this.getTable());  }}>
                            <option default value="">All</option>
                            {this.state.deptFilterOptions.map(item => (
                                <option value={item}>{item}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    &nbsp;&emsp;
                    <FormGroup>
                        <Label>Only Show These Events</Label>
                        <Input type="select" onChange={(e) => { this.setState({ eventPrefixFilter: e.target.value }, () => this.getTable()); }} >
                            <option default value="">All</option>
                            {this.state.eventFilterOptions.map(item => (
                                <option value={item}>{item}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    &nbsp;&emsp;
                    <FormGroup>
                        <Label>Only Show This Building</Label>
                        <Input type="select" onChange={(e) => { this.setState({ buildingFilter: e.target.value }, () => this.getTable());  }}>
                            <option default value="">All</option>
                            {this.state.buildFilterOptions.map(item => (
                                <option value={item}>{item}</option>
                            ))}
                        </Input>
                    </FormGroup>
                </Form>
                <div className="inlineCustom rightAlignCustom">
                    <Button onClick={() => this.toggleAnalyze()}>Analysis...</Button>
                </div>
                <div>
                    {this.state.filteredScheduleData.length == 0 ?
                        <l-hatch
                            size="46"
                            stroke="6"
                            speed="3.5"
                            color="#132E53"
                        /> :
                        <Table striped key={this.state.tableKey}>
                        <thead>
                            <tr>
                                <th>Dept</th>
                                <th>Event Info</th>
                                <th>Classroom</th>
                                <th>Schedule</th>
                                <th>Exam Data</th>
                                <th></th>
                            </tr>
                        </thead>
                            <tbody>
                                {this.state.filteredScheduleData.map(item => (
                                <tr>
                                    <td style={item.conflictcount == "Missing Data" ? { color: 'red' } : item.conflictcount != "No Conflict" ? { color: '#FFA500' } : {}}><TooltipItem id={item.pk} title={item.conflictcount.replaceAll(";", "\n")}>{item.dept}</TooltipItem></td>
                                    <td style={item.conflictcount == "Missing Data" ? { color: 'red' } : item.conflictcount != "No Conflict" ? { color: '#FFA500' } : {}}><TooltipItem id={item.pk + 1} title={item.conflictcount.replaceAll(";", "\n")}>{item.eventdata}</TooltipItem></td>
                                    <td style={item.conflictcount == "Missing Data" ? { color: 'red' } : item.conflictcount != "No Conflict" ? { color: '#FFA500' } : {}}><TooltipItem id={item.pk + 2} title={item.conflictcount.replaceAll(";", "\n")}>{item.building} {item.room}</TooltipItem></td>
                                    <td style={item.conflictcount == "Missing Data" ? { color: 'red' } : item.conflictcount != "No Conflict" ? { color: '#FFA500' } : {}}><TooltipItem id={item.pk + 3} title={item.conflictcount.replaceAll(";", "\n")}>
                                        {item.days}<br />{item.classstart} - {item.classend}
                                    </TooltipItem></td>
                                    <td>
                                        {this.props.editLock &&
                                            <div>
                                                {item.date}  {item.starttime} - {item.endtime} in {item.exambuild} {item.examroom}
                                            </div>
                                        }
                                        {!this.props.editLock && <Form inline className="d-flex">
                                            <FormGroup>
                                                <Label>Exam Date</Label>
                                                <Input
                                                    size="sm"
                                                    type="date"
                                                    name="examdate"
                                                    id="examdate"
                                                    invalid={this.state.badDate && this.state.badDateRecord == item.pk}
                                                    defaultValue={item.date}
                                                    onBlur={(e) => this.changeSched(item.pk, "DATE", e.target.value)} />
                                                <FormFeedback tooltip>Your date is too long. Please re-enter the exam date.</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Exam Start Time</Label>
                                                <Input
                                                    size="sm"
                                                    type="time"
                                                    name="examstart"
                                                    id="examstart"
                                                    defaultValue={item.starttime}
                                                    invalid={this.state.timeError && this.state.timeErrorRecord == item.pk}
                                                    onBlur={(e) => this.checkTimeIssue(e.target.value, item.endtime, item.pk, "START")} />
                                                <FormFeedback tooltip>Exams must start before they can end</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Exam End Time</Label>
                                                <Input
                                                    size="sm"
                                                    type="time"
                                                    name="examend"
                                                    id="examend"
                                                    defaultValue={item.endtime}
                                                    invalid={this.state.timeError && this.state.timeErrorRecord == item.pk}
                                                    onBlur={(e) => this.checkTimeIssue(item.starttime, e.target.value, item.pk, "END")} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Exam Building</Label>
                                                <Input size="sm" type="select" name="exambuild" id="exambuild" defaultValue={item.exambuild} onChange={(e) => this.changeSched(item.pk, "BUILD", e.target.value)} >
                                                    {this.state.buildSet.filter(remove => remove.exambuild !== item.exambuild).map(buildOption => (
                                                        <option value={buildOption.buildcode} selected={buildOption.buildcode == item.exambuild ? true : false}>{buildOption.buildname}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Room</Label>
                                                <Input size="sm" type="select" name="examroom" id="examroom" defaultValue={item.examroom} onChange={(e) => this.changeSched(item.pk, "ROOM", e.target.value)} >
                                                    {this.state.roomSet.filter(remove => remove.buildcode == item.exambuild).map(roomOption => (
                                                        <option selected={roomOption.roomid == item.examroom ? true : false}>{roomOption.roomid}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Form>}
                                    </td>
                                    <td><Button outline color="warning" style={{ visibility: !this.props.editLock ? 'visible' : 'hidden' }} onClick={() => this.manualExclude(item.pk)}>Exclude</Button><br />
                                        <Button outline color="danger" style={{ visibility: !this.props.editLock ? 'visible' : 'hidden' }} onClick={() => this.deleteSched(item.pk)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>} 
                </div>
            </div>
            );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(ExScheduling);